import React, { useState } from 'react';
import { sendRecapOnDemand } from '../services/apiService';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';

const SendRecapScreen: React.FC = () => {
  const [message, setMessage] = useState<string>('');
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleSendRecap = async () => {
    try {
      const force_send_params = {
        start_date: startDate?.toISOString(),
        end_date: endDate?.toISOString()
      };

      const response = await sendRecapOnDemand(force_send_params);
      setMessage(response.message);
    } catch (error) {
      setMessage('Failed to send recap email');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-3xl font-semibold mb-4">Send Recap Email</h1>
      <div className="mb-4">
        <label className="block mb-2">Start Date</label>
        <DatePicker
          selected={startDate}
          onChange={date => setStartDate(date)}
          className="p-2 border border-gray-300 rounded"
          dateFormat="yyyy-MM-dd"
        />
      </div>
      <div className="mb-4">
        <label className="block mb-2">End Date</label>
        <DatePicker
          selected={endDate}
          onChange={date => setEndDate(date)}
          className="p-2 border border-gray-300 rounded"
          dateFormat="yyyy-MM-dd"
        />
      </div>
      <button
        onClick={handleSendRecap}
        className="mb-4 p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Send Recap Email
      </button>
      {message && (
        <div className="mt-4 p-4 bg-white rounded shadow">
          <p>{message}</p>
        </div>
      )}
    </div>
  );
};

export default SendRecapScreen;
